import * as React from 'react';

import { SignInButton } from './SignInButton/SignInButton';

export const NotSignedInActions = () => <SignInButton />;
